<script>
	export let name;	
	import {Route} from 'tinro';
	import Covidupdate from './Covidupdate.svelte'
	import Requestappointment from './Requestappointment.svelte';
	import Services from './Services.svelte';
	import Ourteam from './Ourteam.svelte'
	import Specialoffers from './Specialoffers.svelte'
	import Beforeafter from './Beforeafter.svelte';
	import Reviews from './Reviews.svelte'
	import Contactus from './Contactus.svelte';
	import Footer from './components/Footer.svelte'
</script>

<div class="navbar">
	<a class="logo" href="/">
		<img src="/assets/logosfd.png" alt="Shoreline Family Dentistry Logo" title="Shoreline Family Dentistry Logo" height="100"/>
	  </a>
	<a class="navi" href="/">Home</a>
	<!--<a href="/covid-update">COVID-19 Update</a>-->
	<a class="navi" href="/request-an-appointment">Request an Appointment</a>
	<a href="/special-offers">Special Offers</a>
	<a class="navi" href="/services">Services</a>
	<!--
	<div class="dropdown">
		<button class="dropbtn">Services
		  <i class="fa fa-caret-down"></i>
		</button>
		<div class="dropdown-content">
		  <a href="/about-us">About Us</a>
		  <a href="/special-offers">Special Offers</a>
		  <a href="/services">Services</a>
		  <a href="/reviews">Reviews</a>
		</div>
	</div>
	-->
	<div class="dropdown">
	  <button class="dropbtn">About</button>
	  <div class="dropdown-content">
		<a href="/our-team">Our Team</a>
		<a href="/before-and-after">Before and After</a>
		<a href="/reviews">Reviews</a>
	  </div>
	</div>
	<a class="navi" href="/contact-us">Contact Us</a>
</div>


<Route path="/">
	<main>
		<div class="coverimg">
			<p class="title"><b>Welcome to<br>Shoreline Family Dentistry</b></p>
			<br><br><br><br><br><br><br><br><br><br>
			<a class="coverbtn" href="/request-an-appointment">Request an Appointment Today!</a>
			<br><br>
		</div>
		<hr>
		<div class="content">
			<div class="big-font">
				<p>Shoreline Family Dentistry has been providing dental care in Shoreline since 1999. Our staff strives to provide the latest and best dental care to the Shoreline community.  Dr. Kang and staff have a genuine concern for the well-being of our patients. Your health is our top priority and our goal is to keep your teeth healthy, and your smile bright!</p>
				<br>
				<p>Learn more about...</p>
			</div>
			<div class="row">
				<a class="btn contents" href="/special-offers/#">Special Offers</a>
				<div class="void"></div>
				<a class="btn contents" href="/services/#">Our Services</a>
				<div class="void"></div>
				<a class="btn contents" href="/our-team/#">Our Team</a>
				<div class="void"></div>
				<a class="btn contents" href="/before-and-after/#">Before and Afters</a>
			</div>
			<br><br>
			<!--<div class="big-font">
				<p>Also check out our reviews!</p>
			</div>
			<div class="row">

				<div class="void"></div>
				<a class="btn contents" href="/reviews">Reviews</a>
				<div class="void"></div>
			</div>-->
			
			<br><br>
			<p>Smile for a lifetime...</p>
		</div>
		
	</main>
</Route>

<Route path="/covid-update">
	<Covidupdate />
</Route>
<Route path="/request-an-appointment">
	<Requestappointment />
</Route>
<Route path="/services">
	<Services />
</Route>
<Route path="/special-offers">
	<Specialoffers />
</Route>
<Route path="/our-team">
	<Ourteam />
</Route>
<Route path="/before-and-after">
	<Beforeafter />
</Route>
<Route path="/reviews">
	<Reviews />
</Route>
<Route path="/contact-us">
	<Contactus />
</Route>

<Footer />

<style>
	main {
		text-align: center;
		color: rgb(52, 80, 117);
		
	}

	.title {
		color: white;
		font-size: 64px;
	}

	.logo {
		margin-right: auto;

	}

	.content {
		text-align: center;
		padding: 1em;
		max-width: 1000px;
		margin: 0 auto;
	}
	.big-font{
		font-size: 24px;
	}

	.row{
		display: flex;
		padding: 0em 3em;
	}

	/* Navbar container */
	.navbar {
	overflow: hidden;
	background-color: hsl(0, 0%, 100%);
	/*font-family: "Raleway", sans-serif;*/
	max-width: 1400px;
	display: flex;
	align-items: center;
	margin: auto;

	}

	/* Links inside the navbar */
	.navbar a {
	float: left;
	font-size: 16px;
	color: rgb(52, 80, 117);
	text-align: center;
	padding: 14px 16px;
	text-decoration: none;
	transition: 0.1s;
	}

	/* The dropdown container */
	.dropdown {
	float: left;
	overflow: hidden;
	}

	/* Dropdown button */
	.dropdown .dropbtn {
	font-size: 16px;
	border: none;
	outline: none;
	color: rgb(52, 80, 117);
	padding: 14px 16px;
	background-color: inherit;
	font-family: inherit; /* Important for vertical align on mobile phones */
	margin: 0; /* Important for vertical align on mobile phones */
	transition: 0.1s;
	}

	/* Add a red background color to navbar links on hover */
	.navi:hover, .dropdown:hover .dropbtn {
	/*background-color: rgb(218, 244, 255);*/
	border-bottom-style: solid;
	border-bottom-color: rgb(52, 80, 117);
	}

	/* Dropdown content (hidden by default) */
	.dropdown-content {
	display: none;
	position: absolute;
	background-color: #f9f9f9;
	min-width: 160px;
	box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
	z-index: 1;
	}

	/* Links inside the dropdown */
	.dropdown-content a {
	float: none;
	color: rgb(52, 80, 117);
	padding: 12px 16px;
	text-decoration: none;
	display: block;
	text-align: left;
	}

	/* Add a grey background color to dropdown links on hover */
	.dropdown-content a:hover {
	background-color: #ddd;
	}

	/* Show the dropdown menu on hover */
	.dropdown:hover .dropdown-content {
	display: block;
	}

	.btn {
		background-color: rgb(116, 176, 211);
		border: none;
		color: white;
		padding: 12px 30px;
		cursor: pointer;
		font-size: 20px;
		text-decoration: none;
		transition: .1s;
	}

	.contents {
		flex: 30%;
		padding: 16px 16px;
	}
	.void {
		flex:5%;
	}

	/* Darker background on mouse-over */
	.btn:hover {
		background-color: rgb(52, 80, 117);
	}

	.coverbtn {
		border-style: solid;
		border-width: 2px;
		border-color: white;
		color: white;
		padding: 12px 30px;
		cursor: pointer;
		font-size: 20px;
		text-decoration: none;
		transition: .1s;
	}

	.coverbtn:hover{
		background-color: rgb(255, 255, 255);
		color: rgb(52, 80, 117);
	}

	.coverimg {
		background: url("/assets/shoreline.jpg") no-repeat center center fixed;
		-webkit-background-size: cover;
		-moz-background-size: cover;
		-o-background-size: cover;
		background-size: cover;
		background-color: #cccccc;
		max-width: none;
		padding: 16px 0px 64px 0px;
	}

	
</style>